import { BaseAsset } from './BaseAsset';
import { QuestionResponse } from './QuestionResponse';

export class QuestionSetAsset extends BaseAsset{
    coverPage: boolean;
    planeColour: string;
    backgroundOpacity: number;
    title: string;
    titleSize: number;
    titleColour: string;
    questionSetDescription: string;
    questionSetDescriptionSize: number;
    questionSetDescriptionColour: string;
    minScoreToPass: number;
    confirmationPage: boolean;
    resultsPage: boolean;
    endPageTitleSize: number;
    endPageTitleColour: string;
    endPageTextSize: number;
    endPageTextColour: string;
    coverPageFontFamily: string;
    confirmationPageFontFamily: string;
    resultsPageFontFamily: string;
    coverPageTitleFontFamily: string;
    confirmationPageTitleFontFamily: string;
    resultsPageTitleFontFamily: string;
    resultsPageTitleSize: number;
    resultsPageTitleColour: string;
    resultsPageTextSize: number;
    resultsPageTextColour: string;
    confirmationPageTitle: string;
    confirmationPageAnswersCompletedText: string;
    confirmationPageAnswersNotCompletedText: string;
    resultsPageTitle: string;
    resultsPageText: string;
    resultsPagePassedText: string;
    resultsPageFailedText: string;
    questionIndex: number;
    submitted: boolean;
}